import { useCallback, useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { ScheduleWorkingRoutesListInterface } from "../../../redux/interfaces/expedition.interface";
import ModalList, {
  ModalListItem,
} from "../../../components/misc/ModalList/ModalList";
import {
  fetchAwbHistory,
  fetchTransferPickUpRoute,
  getAllWorkingRoutes,
} from "../../../redux/api/expedition.api";
import CustomButton from "../../../components/CustomButton";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../helpers/apiHelper";
import {
  clearAllWorkingRoutes,
  setClientsSelectedActiveExpeditionForPickUpRoute,
} from "../../../redux/reducer/expedition.reducer";
import useRoutesHelper from "../../../hooks/useRoutesHelper";
import useTableCtx from "../../../components/tables/tableContext/useTableCtx";

function PickUpRouteTransferActiveExpeditionModal() {
  const dispatch = useAppDispatch();
  const { setSelectedItems } = useTableCtx() || {};
  const { routeParams } = useRoutesHelper();

  const {
    allWorkingRoutes: {
      data: { data: allWorkingRoutes },
    },
    clientsSelectedActiveExpeditionForPickUpRoute,
  } = useAppSelector((state) => state.expedition);

  const [selectedRoute, setSelectedRoute] =
    useState<ScheduleWorkingRoutesListInterface | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    return () => {
      dispatch(clearAllWorkingRoutes());
      setSelectedRoute(null);
    };
  }, [dispatch]);

  const routes = useMemo<ModalListItem[]>(
    () =>
      allWorkingRoutes.map((item) => ({
        ...item,
        id: item.id_ruta,
        label: item.denumire,
        backgroundColor:
          item.id_ruta === selectedRoute?.id_ruta ? "warning" : "info",
      })),
    [allWorkingRoutes, selectedRoute?.id_ruta],
  );

  const workingRoutesModalActions = useCallback(
    ({ search }: { search: string }) => {
      if (clientsSelectedActiveExpeditionForPickUpRoute.length) {
        dispatch(
          getAllWorkingRoutes({
            page: 1,
            perPage: 50,
            route: search,
          }),
        );
      }
    },
    [clientsSelectedActiveExpeditionForPickUpRoute, dispatch],
  );

  const onClose = useCallback(() => {
    dispatch(setClientsSelectedActiveExpeditionForPickUpRoute([]));
    setSelectedRoute(null);
    setSelectedItems?.([]);
  }, [dispatch, setSelectedItems]);

  const handleOnSubmit = useCallback(
    async ({ handleClose }: { handleClose?: () => void }) => {
      if (
        !clientsSelectedActiveExpeditionForPickUpRoute.length ||
        !selectedRoute
      ) {
        return;
      }

      setIsLoading(true);
      const resultAction = await dispatch(
        fetchTransferPickUpRoute({
          id_ruta: selectedRoute.id_ruta,
          selectedActiveExpeditions:
            clientsSelectedActiveExpeditionForPickUpRoute,
        }),
      );
      setIsLoading(false);

      if (
        checkEndpointStatus(resultAction, fetchTransferPickUpRoute) ===
        endpointStatus.fulfilled
      ) {
        const {
          client,
          doc_trans,
          nodDestinatie,
          pctlivrare,
          route,
          status,
          page,
          rowsPerPage,
        } = routeParams;

        dispatch(
          fetchAwbHistory({
            page,
            perPage: rowsPerPage,
            doc_trans,
            nodDestinatie,
            pctlivrare,
            status,
            id_client: client,
            route,
          }),
        );

        setSelectedItems?.([]);
        setSelectedRoute(null);
        handleClose?.();
      }
    },
    [
      clientsSelectedActiveExpeditionForPickUpRoute,
      dispatch,
      routeParams,
      selectedRoute,
      setSelectedItems,
    ],
  );

  return (
    <ModalList
      dynamicModalOpen={
        clientsSelectedActiveExpeditionForPickUpRoute.length > 0
      }
      onClose={onClose}
      label="Ruta Preluare"
      modalTitle="Ruta Preluare"
      searchPlaceholder="Cauta ruta"
      items={routes}
      modalActions={workingRoutesModalActions}
      selectedItem={{
        id: selectedRoute?.id_ruta || "",
        label: selectedRoute?.denumire || "",
      }}
      setSelectedItem={setSelectedRoute}
      withCloseAfterSelect={false}
      CustomModalFooter={({ handleClose }: any) => (
        <div className="flex justify-between gap-4">
          <CustomButton onClick={handleClose}>Inapoi</CustomButton>
          <CustomButton
            variant="contained"
            loading={isLoading}
            onClick={() => handleOnSubmit({ handleClose })}>
            Salveaza
          </CustomButton>
        </div>
      )}
      CustomOpenModalComponent={() => <></>}
    />
  );
}

export default PickUpRouteTransferActiveExpeditionModal;
